import { STORAGE_KEYS } from '../config';
import {
  CampaignType,
  MarketingStrategy,
  StandardCoupon,
  StrategyContext,
} from '../types';

export abstract class BaseCampaignStrategy implements MarketingStrategy {
  abstract type: CampaignType;
  abstract priority: number;

  constructor(protected topCoupon: StandardCoupon | null) {}

  abstract canActivate(): boolean | Promise<boolean>;
  abstract show(context?: StrategyContext): void | Promise<void>;

  protected shouldShowModal(storageKey: string): boolean {
    return !localStorage.getItem(storageKey);
  }

  protected markModalShown(storageKey: string): void {
    localStorage.setItem(storageKey, 'true');
  }
}
